import { EligibleAddonsQuery } from '__generated__/EligibleAddonsQuery.graphql';

type PromotionDetails =
  EligibleAddonsQuery['response']['eligibleAddons']['addonsProducts']['accessoryBundles'][0]['promotions'];

interface DealDetails {
  text?: string;
  tag?: string;
}

export function getDealDetails(promotions: PromotionDetails): DealDetails {
  return {
    text: promotions?.find((promo) => promo?.productType === 'DEAL')
      ?.longDescription,
    tag: promotions?.find((promo) => promo?.productType === 'MARKETING')?.name,
  };
}
